import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Introduction from "./components/Introduction";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import AboutMe from "./components/AboutMe";
import Chatbot from "./components/Chatbot";
import "./App.css";
import ReactGA from "react-ga";

const App = () => {
  const [activeSection, setActiveSection] = useState('home');

  // Initialize Google Analytics only once
  useEffect(() => {
    ReactGA.initialize("UA-63454306-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    console.log(
      "%cHey there, curious person! Thanks for checking under the hood. This is my site. Built with care.\nHopefully there aren't any errors above these lines. 🙂\nIf you see some, send me an email, would you please?",
      "color: #4e54c8; font-size: 1.1em; line-height: 1.4;"
    );
  }, []);

  // Custom scroll tracking
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'projects', 'contact'];
      const headerHeight = document.getElementById('navbar')?.offsetHeight || 80;
      const scrollPosition = window.scrollY + headerHeight + 20; // More accurate offset

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;
          
          // Check if we're in this section
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };

    // Handle hash changes (when clicking navigation links)
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash && ['home', 'about', 'projects', 'contact'].includes(hash)) {
        setActiveSection(hash);
        
        // Ensure smooth scrolling to the section
        const targetSection = document.getElementById(hash);
        if (targetSection) {
          const headerHeight = document.getElementById('navbar')?.offsetHeight || 80;
          const targetPosition = targetSection.offsetTop - headerHeight - 20;
          
          // Use requestAnimationFrame for smoother scrolling on mobile
          requestAnimationFrame(() => {
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('hashchange', handleHashChange);
    
    // Check initial hash
    handleHashChange();
    // Check initial scroll position after a short delay to ensure DOM is ready
    setTimeout(handleScroll, 100);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className="app">
      <Header activeSection={activeSection} />
      <div id="home">
        <Introduction />
      </div>
      <div id="about">
        <AboutMe />
      </div>
      <div id="projects">
        <Projects />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Chatbot />
    </div>
  );
};

export default App;
